module.exports = "<h2>Trips</h2> <crud-clerk-trip-curate></crud-clerk-trip-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/whereabouts/inspect.travels.trips.html
// module id = 4184
// module chunks = 86